// Brokerage / Sub-Broker PR-7 — the broker-side "Affiliation Requests" reads +
// two-sided consent actions. A brokerage (or staff on its behalf) proposes an
// affiliation; the broker accepts (joins the firm, leaving any current one) or
// declines from their own portal. All calls hit /api/portal/broker/affiliations*.

import { portalApi } from "./client";

export interface BrokerAffiliationRequest {
  affiliationId: string;
  brokerageId: string;
  brokerageName: string;
  status: string; // Proposed | Active
  proposedAt: string;
  acceptedAt: string | null;
  /** PR-8 — the broker's own immutable BrokerType is Junior (identical on every
   *  row). Drives the type-aware financial disclosure on the accept screen: a
   *  Junior is paid through the firm; an Independent broker is paid directly. */
  isJunior: boolean;
}

export const brokerAffiliationsApi = {
  /** The broker's pending (Proposed) + current (Active) firm affiliations. */
  list: () => portalApi.get<BrokerAffiliationRequest[]>("/broker/affiliations"),

  /** Accept a proposed affiliation → Active (leaving any current firm). */
  accept: (affiliationId: string) =>
    portalApi.post<BrokerAffiliationRequest>(`/broker/affiliations/${affiliationId}/accept`),

  /** Decline a proposed affiliation → Declined (optional reason). */
  decline: (affiliationId: string, reason?: string) => {
    const suffix = reason && reason.trim() ? `?reason=${encodeURIComponent(reason.trim())}` : "";
    return portalApi.post<BrokerAffiliationRequest>(
      `/broker/affiliations/${affiliationId}/decline${suffix}`,
    );
  },
};
